/**
 * @description if
 * @author duanjun
 * @date
 */

interface IIfProps {
    condition: boolean;
    children: JSX.Element | null;
}

function If(props: IIfProps) {
    if (props.condition) {
        return props.children;
    }
    return null;
}

export { If };

export default If;
